import _toConsumableArray from "/codebuild/output/src2989845404/src/tpp-frontend/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import { defaultTheme as t, isDesignToken as n, cssNameTransform as r } from "@aws-amplify/ui";
import { stylePropsToThemeKeys as o } from "./constants.js";

var e = function e(t) {
  return "string" == typeof t && t.length > 0;
},
    l = function l(t) {
  return "function" == typeof t;
},
    i = function i(t) {
  return "string" == typeof t && 0 === t.length;
},
    s = function s(t) {
  return null == t || i(t);
},
    f = function f(t, n) {
  var r = n - t + 1;
  return Array.from({
    length: r
  }, function (n, r) {
    return r + t;
  });
},
    p = function p(t, n) {
  return n ? "".concat(t, "--").concat(n) : null;
},
    u = function u(t, n, r) {
  return r ? "".concat(t, "--").concat(n) : null;
},
    a = function a(e, l) {
  if ("string" != typeof l) return l;
  if (l.includes(" ")) return l.split(" ").map(function (t) {
    return a(e, t);
  }).join(" ");
  var i = l.split("."),
      s = o[e];
  var f = t.tokens[s];

  for (var _t = 0; _t < i.length && f; _t++) {
    f = f[i[_t]];
  }

  return n(f) ? "var(--".concat(r({
    path: [o[e]].concat(_toConsumableArray(i))
  }), ")") : l;
};

export { p as classNameModifier, u as classNameModifierByFlag, a as getCSSVariableIfValueIsThemeKey, f as getConsecutiveIntArray, i as isEmptyString, l as isFunction, s as isNullOrEmptyString, e as strHasLength };